import { createMachine } from 'xstate';
import { Events, CancelSubscriptionContext } from './types';

const initialContext = {
  error: null,
} as CancelSubscriptionContext;

export const cancelSubscription = createMachine<
  CancelSubscriptionContext,
  Events
>({
  id: 'cancelSubscription',
  predictableActionArguments: true,
  initial: 'idle',
  context: initialContext,
  states: {
    idle: {
      on: {
        CANCEL_SUBSCRIPTION: {
          target: 'cancelSubscription',
        },
      },
    },
    cancelSubscription: {
      invoke: {
        src: 'cancelSubscription',
        onDone: {
          target: 'success',
          actions: 'updateSubscription',
        },
        onError: {
          target: 'error',
          actions: 'setError',
        },
      },
    },
    success: {
      type: 'final',
    },
    error: {
      type: 'final',
    },
  },
});
